import { EnumOption } from './enum-option';
import { createEnumOptions } from '../../shared/utils';

export enum ActionStatus {
  'Not Started' = 0,
  'In Progress' = 1,
  Completed = 2,
  Failed = 3,
  Skipped = 4,
}

export const ActionStatusList: EnumOption[] = createEnumOptions(ActionStatus);
